var newRebateSearch = {
  searchValue: '',
  rebateCategory: '',
  rebateinfo: [],
  rebateNote: '<span class="smallerfont">*Rebate estimate from <strong>{}</strong>. <a class="search-again link" href="#">Change zip code or utility</a>.</span>',
  pecoNote: '<span class="smallerfont">*Min. cost of $1/fixture. Rebate estimate from <strong>{}</strong>. <a class="search-again link" href="#">Change zip code or utility</a>.</span>',
  noUtilNote: '<span class="smallerfont"><a class="search-again link" href="#">Change zip code or utility</a>.</span>',
  multUtil: false,
  utilityDropdown: document.getElementsByClassName("utilities")[0],
  initAlready: false,
  initAlready: false,

  // UI state helpers for mockup behavior
  _lastZip: '',
  _pendingFetch: false,
  _pendingUtility: null,

  producPageSetup: function (rCat) {
    newRebateSearch.rebateCategory = rCat;

    // Gate: only show the finder when the parent product has the required tag.
    // We hide the top-level Shopify section wrapper so the theme's section margins don't leave blank space.
    /* if (!newRebateSearch.enforceRequiredTag()) {
      return;
    } */
    var vsku = ($('.rebate_container .sku').val() || '').toString();
    if (!vsku.trim()) {
      console.warn('Rebate Finder: missing SKU (.rebate_container .sku). Widget will not initialize.');
      return;
    }
    var vskuArray = vsku.split(/(\s+)/);
    vskuArray = vskuArray.filter(element => element !== ' ');

    var finalSku = "";

    if (vskuArray.length === 1) {
      finalSku = vskuArray[0];
    } else {
      let resultArray = [];
      for (const sku of vskuArray) {
        if (sku.includes('(')) {
          break;
        }
        resultArray.push(sku);
      }
      finalSku = resultArray.join(' ');
    }

    $('.sku').prop('readonly', true);
    $('.skuwrapper').addClass('hide');
    $('table#sortable').addClass('hide');
    $('.first-search').removeClass('hide');
    $('.single-result').removeClass('hide');

    newRebateSearch.searchValue = finalSku;

    newRebateSearch.setupEvents();

    // If cookie exists, put zip code in form and dispatch change event
    if (!!Cookies.get('eled_rebateinfo')) {
      $('.rbbox').hide();
      newRebateSearch.rebateinfo = JSON.parse(Cookies.get('eled_rebateinfo'));
      document.getElementsByClassName("zip_code")[0].value = newRebateSearch.rebateinfo[0];
      if(!newRebateSearch.initAlready) {
        document.getElementsByClassName("zip_code")[0].dispatchEvent(new Event('input'));
        newRebateSearch.initAlready = true;
      }
    }
  },

  setupEvents: function () {
    /* Set up click and change events */

    // IMPORTANT: producPageSetup() can run multiple times (dev SKU apply, Shopify re-init).
    // De-dupe handlers so events don't fire twice.
    var $container = $('.rebate_container');
    $container.find('.zip_code, .utilities').off('.rf');
    $container.find('.find-rebates-btn').off('.rf');
    $container.find('.sku').off('.rf');
    $container.off('click.rf', 'a.search-again');

    // Zip and utility changes still drive behavior
    $container.find('.zip_code, .utilities').on('input.rf', newRebateSearch.fieldChange);

    // Typing a zip and clicking away should refresh utility options (mockup behavior)
    /* $container.find('.zip_code').on('blur.rf', function () {
      var zipVal = ($('.rebate_container .zip_code').val() || '').trim();
      if (zipVal.length === 5 && zipVal !== newRebateSearch._lastZip) {
        newRebateSearch._lastZip = zipVal;

        // Zip change invalidates previous utility selection
        newRebateSearch._pendingUtility = null;
        newRebateSearch._pendingFetch = false;
        newRebateSearch.rebateinfo[1] = null;
        Cookies.set('eled_rebateinfo', JSON.stringify(newRebateSearch.rebateinfo));

        // Reset UI state immediately; list will repopulate after query
        $('.rebate_container .utilities').val('choose utility');
        $('.rebate_container .rf-success').hide();
        $('.rebate_container .rf-warn').hide();

        newRebateSearch.queryZip($('.rebate_container .zip_code'));
      }
    }); */

    // Mockup UX has an explicit "Find Rebates" button. Support it (dev harness + Shopify section).
    $container.find('.find-rebates-btn').on('click.rf', function () {
      var zipVal = ($('.rebate_container .zip_code').val() || '').trim();
      var utilVal = $('.rebate_container .utilities').val();

      // Always behave as a single explicit action: validate fields, refresh utilities if needed, then fetch rebates if possible.
      if (zipVal.length !== 5) {
        return;
      }

      // If zip changed since last lookup, refresh utility list.
      // If a utility was selected, try to keep it if still available; otherwise reset to choose utility.
      if (zipVal !== newRebateSearch._lastZip) {
        newRebateSearch._lastZip = zipVal;
        newRebateSearch._pendingUtility = (utilVal && utilVal !== 'choose utility') ? utilVal : null;
        newRebateSearch._pendingFetch = !!newRebateSearch._pendingUtility;
        newRebateSearch.queryZip($('.rebate_container .zip_code'));
        return;
      }

      // Zip already up to date: just fetch if utility is selected; otherwise refresh utilities.
      if (!utilVal || utilVal === 'choose utility') {
        newRebateSearch.queryZip($('.rebate_container .zip_code'));
        return;
      }

      newRebateSearch.getRebates();
    });

    // Change zip/utility link (modal removed). Just re-open the form.
    $container.on('click.rf', 'a.search-again', function (e) {
      e.preventDefault();
      // Show the form again
      $('.first-search-box').show();
      // Hide panels
      $('.rebate_container .rf-success').hide();
      $('.rebate_container .rf-warn').hide();
      // Focus zip for quick retry
      $('.rebate_container .zip_code').trigger('focus');
    });

    // Reset button: clear zip, utility, cookie, and results (fresh load behavior)
    $container.off('click.rf', '.rf-reset-btn');
    $container.on('click.rf', '.rf-reset-btn', function (e) {
      e.preventDefault();
      newRebateSearch.resetForm();
    });

    $container.find('.sku').on('change.rf', function () {
      // Save sku to variable
      newRebateSearch.searchValue = $('.rebate_container .sku').val();
      if (newRebateSearch.searchValue == '') {
        newRebateSearch.searchValue == ' ';
      }
    });
  },

  // Handles zip code and utility changes
  fieldChange: function (e) {
    // Handles zip code and utility changes
    var changedElement = $(e.target);
    if (changedElement.hasClass('zip_code')) {
      if ($('.rebate_container .zip_code').val().length == 5) {
        newRebateSearch.queryZip(changedElement);
      }
    } else {
      if (changedElement[0].value != "choose utility") {
        // Clear visible panels immediately so switching utilities doesn't leave stale content on screen.
        $('.rebate_container .rf-success').hide();
        $('.rebate_container .rf-warn').hide();
        newRebateSearch.getRebates(changedElement);
      }
    }
  },

  enforceRequiredTag: function () {
    var root = document.getElementById('rebate-finder');
    if (!root) return true; // if markup isn't present, don't block anything

    var required = (root.getAttribute('data-required-tag') || '').trim();
    if (!required) return true; // no gating configured

    // Tags supplied by Liquid as a delimiter-separated string
    var tagsRaw = (root.getAttribute('data-product-tags') || '').toString();
    var tags = tagsRaw
      .split('||')
      .map(function (t) { return (t || '').trim(); })
      .filter(Boolean);

    var hasTag = tags.indexOf(required) !== -1;
    if (hasTag) return true;

    // Walk up and hide the whole section wrapper (removes top/bottom theme margins)
    var wrapper = root.closest('section.shopify-section') || root.closest('[id^="shopify-section-"]') || root.parentElement;
    if (wrapper) {
      wrapper.classList.add('rf-section-hidden');
    } else {
      root.style.display = 'none';
    }

    return false;
  },

  resetForm: function () {
    try {
      Cookies.remove('eled_rebateinfo');
    } catch (e) {
      // ignore
    }

    newRebateSearch.rebateinfo = [];
    newRebateSearch._lastZip = '';
    newRebateSearch._pendingFetch = false;
    newRebateSearch._pendingUtility = null;

    // Clear fields
    var $zip = $('.rebate_container .zip_code');
    var $util = $('.rebate_container .utilities');
    $zip.val('');

    if ($util && $util.length) {
      // Restore initial option only
      $util.html('<option value="choose utility">Click Here to Choose Your Utility</option>');
      $util.val('choose utility');
    }

    // Hide results panels
    $('.rebate_container .rf-success').hide().empty();
    $('.rebate_container .rf-warn').hide().empty();

    // Clear legacy containers (kept hidden, but reset anyway)
    $('.rebate_container .single-result').empty();
    $('.rebate_container .rebate-text').empty();
    $('.rebate_container .rebatefootnote').empty();

    // Show the form like a fresh page load
    $('.first-search-box').show();

    // Focus zip for convenience
    $zip.trigger('focus');
  },

  queryZip: function (zipField) {
    // Only runs when zip changes


    var zip = zipField[0].value; // has to happen if above is commented out

    // Save zip to cookie
    newRebateSearch.rebateinfo[0] = $('.zip_code').val();
    Cookies.set('eled_rebateinfo', JSON.stringify(newRebateSearch.rebateinfo));

    // Create request
    var requestObject = { zip: zip, product: newRebateSearch.searchValue };
    var requestData = JSON.stringify(requestObject);

    var url = "https://shopapps.mannsmt.com/eled-apps/miscScripts/briteswitchAPI/handleBriteswitchAPI.php";
    newRebateSearch.postData(url, requestData).then(response => {
      handleRebate(response);
    }).catch((error) => {
      console.error('Error querying utilities:', error);
      this.handleNoUtilities('Error');
    });
    
    function handleRebate(response, attempts = 0) {
      //If rate limiting occurs 5 times in a row, exit the function
      if(attempts == 5)
        throw new Error("Tried 5 times, exiting...");

      //If a rate limit occurs, try again after 0.2 seconds
      if (JSON.parse(response.data).status_message == "Too many requests") {
        setTimeout(handleRebate, 200, response, attempts++);
      }

      response = JSON.parse(response.data);
      var status = response.status_message;
      responseData = response.data;

      // Handle responses
      if (status == "Multiple Utilities") {
        // Now returns 'mult util' whether its one or multiple
        newRebateSearch.buildUtilList(responseData)
      }
      else {
        console.log(status)
        newRebateSearch.invalidUtility(responseData, status, zipField)
      }
    }
  },

  invalidUtility: function (responseData, status, zipField) {
    // Show "no rebates for location" message (mockup-aligned)
    var optionsHTML = [];
    newRebateSearch.utilityDropdown.innerHTML = optionsHTML;

    var warn = document.querySelector('.rebate_container .rf-warn');
    var success = document.querySelector('.rebate_container .rf-success');
    if (success) success.style.display = 'none';

    if (warn) {
      warn.innerHTML = [
        '<h4>There are currently no rebates available for this location.</h4>',
        '<div class="rebate-finder__cta">',
        '<p><b>Need help?</b> Call <a href="tel:2153557200">215-355-7200</a> or email <a href="mailto:lights@eledlights.com">lights@eledlights.com</a> to speak with a member of our team.</p>',
        '</div>'
      ].join('');
      warn.style.display = '';
    }

    // Keep legacy writes (hidden by CSS) so behavior remains compatible
    $('.single-result').html('<div class="rebate_result">There are no rebates currently available for this location.<br>Try&nbsp;another&nbsp;zip&nbsp;code.</div>');
    $('.rebate-text').html('<div class="rebate_result"><span style="font-weight: normal; font-size 13px">There are no rebates currently available for this location.</span><br><span class="linewrapper" style="font-weight: normal; font-size: 13px;"><a class="search-again link" href="#">Try&nbsp;another&nbsp;zip&nbsp;code.</a></span></div>');
    $('.rebatefootnote').hide();
  },

  buildUtilList: function (responseData) {
    $('.rebate_result').hide();

    // Add utilities to dropdown
    var optionsHTML = []
    optionsHTML.push('<option value="choose utility">Click Here to Choose Your Utility</option>');
    for (var i = 0; i < responseData.length; i++) {
      var optionText = responseData[i].replace(/ - [A-Za-z]{2}$/, '').replace(/ Co$/, '');
      optionsHTML.push(`<option value="${responseData[i]}">${optionText}</option>`)
    }
    newRebateSearch.utilityDropdown.innerHTML = optionsHTML.join('\n');

    // if zip returns one, or many zip codes
    if (newRebateSearch.utilityDropdown.length > 2) {
      newRebateSearch.multUtil = true;
    } else {
      newRebateSearch.multUtil = false;
    }

    // if a utility is in a cookie and matches utility found in dropdown
    newRebateSearch.rebateinfo = JSON.parse(Cookies.get('eled_rebateinfo'));
    var matchFound = false;
    for (var i = 0; i < newRebateSearch.utilityDropdown.options.length; i++) {
      var option = newRebateSearch.utilityDropdown.options[i];
      if (option.value == newRebateSearch.rebateinfo[1]) {
        matchFound = true;
      }
    }

    // Prefer preserving current/pending selection when the utility list refreshes.
    var desired = newRebateSearch._pendingUtility || newRebateSearch.rebateinfo[1] || null;
    var desiredExists = false;
    if (desired) {
      for (var j = 0; j < newRebateSearch.utilityDropdown.options.length; j++) {
        if (newRebateSearch.utilityDropdown.options[j].value == desired) {
          desiredExists = true;
          break;
        }
      }
    }

    if (desired && desiredExists) {
      $('.utilities').val(desired);

      // If we restored a previously-selected utility (e.g. after hard refresh), run the rebate lookup now.
      // This removes the need for a separate "Find Rebates" click in the multi-utility case.
      newRebateSearch._pendingFetch = false;
      newRebateSearch._pendingUtility = null;
      newRebateSearch.getRebates();
      return;
    } else {
      // Reset to choose utility if selection no longer applies
      $('.utilities').val('choose utility');
      newRebateSearch.rebateinfo[1] = null;
      Cookies.set('eled_rebateinfo', JSON.stringify(newRebateSearch.rebateinfo));
    }

    // If there is only one utility, select it automatically (and persist it).
    // Also run the rebate lookup immediately.
    if (newRebateSearch.multUtil == false && newRebateSearch.utilityDropdown.options.length > 1) {
      var onlyUtil = newRebateSearch.utilityDropdown.options[1].value;
      $('.utilities').val(onlyUtil);
      newRebateSearch.rebateinfo[1] = onlyUtil;
      Cookies.set('eled_rebateinfo', JSON.stringify(newRebateSearch.rebateinfo));

      // Prevent double-fetch: this branch already triggers the rebate lookup.
      newRebateSearch._pendingFetch = false;
      newRebateSearch._pendingUtility = null;

      newRebateSearch.getRebates();
      return;
    }

    // Only auto-fetch when triggered by Find Rebates button with a specific utility selected.
    if (newRebateSearch._pendingFetch) {
      newRebateSearch._pendingFetch = false;
      newRebateSearch._pendingUtility = null;
      if ($('.utilities').val() && $('.utilities').val() !== 'choose utility') {
        newRebateSearch.getRebates();
      }
    } else {
      newRebateSearch._pendingUtility = null;
    }
  },

  getRebates: function () {
    var zip = $('.rebate_container .zip_code').val();
    var utility = $('.rebate_container .utilities').val();

    if (!utility || utility === 'choose utility') {
      return;
    }

    newRebateSearch.rebateinfo[1] = utility;
    Cookies.set('eled_rebateinfo', JSON.stringify(newRebateSearch.rebateinfo));
    var requestObject = { zip: zip, utility: utility, product: newRebateSearch.searchValue };
    var requestData = JSON.stringify(requestObject);
    var url = "https://shopapps.mannsmt.com/eled-apps/miscScripts/briteswitchAPI/handleBriteswitchAPI.php";
    newRebateSearch.postData(url, requestData).then(response => {
      parseRebateData(response);
    });

    function parseRebateData(response, attempts = 0) {
      //If rate limiting occurs 5 times in a row, exit the function
      if (attempts == 5)
        throw new Error("Tried 5 times, exiting...");

      //If a rate limit occurs, try again after 0.2 seconds
      if (JSON.parse(response.data).status_message == "Too many requests") {
        setTimeout(parseRebateData, 200, response, attempts++);
      }

      response = JSON.parse(response.data);
      var status = response.status_message;
      responseData = response.data;

      // console.log("getRebatesResponse: ", response)

      // Debug: show rebate types returned by API (remove later)
      (function rfDebugTypes() {
        try {
          // Prefer a debug element inside the widget, but don't require it to be inside .rebate_container
          var dbgEl = document.querySelector('#rebate-finder .rf-debug') ||
            document.querySelector('.rebate_container .rf-debug') ||
            document.querySelector('.rf-debug');
          if (!dbgEl) return;
          var types = [];
          if (responseData && typeof responseData === 'object') {
            for (var k in responseData) {
              var t = (responseData[k] && responseData[k].RebateType != null) ? String(responseData[k].RebateType) : '';
              if (!types.includes(t)) types.push(t);
            }
          }
          dbgEl.textContent = 'DEBUG — Briteswitch status: ' + status + '\nRebateType values: ' + (types.length ? types.map(x => x === '' ? '[blank]' : x).join(', ') : '(none)');
        } catch (e) {
          // ignore
        }
      })();
      if (status == "Error") {
        // Cannot find product
        $('.rbbox').show();
        var noUtilityText = JSON.parse(requestData).utility.replace(/ - [A-Za-z]{2}$/, '').replace(/ Co$/, '');
        var tags = "?s=" + $('.sku').val() + "&z=" + $('.zip_code').val() + "&u=" + $('.utilities option:selected').text().replaceAll("&", "%26");

        // Mockup-style fail panel
        var warn = document.querySelector('.rebate_container .rf-warn');
        var success = document.querySelector('.rebate_container .rf-success');
        if (success) success.style.display = 'none';
        if (warn) {
          var ICON_PHONE = 'https://cdn.shopify.com/s/files/1/0553/0605/9812/files/Phone-rebate100x100.svg?v=1770905021';
          var ICON_MSG = 'https://cdn.shopify.com/s/files/1/0553/0605/9812/files/Message-rebate100x100.svg?v=1770905021';

          warn.innerHTML = [
            '<h4>' + noUtilityText + ' does not offer instant rebates for this product.</h4>',
            '<div class="rebate-finder__cta">',
            '<p><b>Need help?</b> Call <a href="tel:2153557200">215-355-7200</a> or email <a href="mailto:lights@eledlights.com">lights@eledlights.com</a> to speak with a member of our team.</p>',
            '</div>',
            '<p>Planning a larger project? <strong><a href="/pages/other-savings' + tags + '">Reach out for a bulk price quote</a></strong>.</p>'
          ].join('');
          warn.style.display = '';
        }

        $('.single-result').html('<div class="rebate_result">Instant rebates not currently available from <span class="utilityname">' + noUtilityText + '</span>, but we may be able to find downstream rebates and additional savings. <a class="contactus link"/pages/other-savings' + tags + '" style="font-weight: bold;">Inquire</a><span style="font-weight: normal;"> or </span><span class="linewrapper" style="font-weight: normal;">try&nbsp;another&nbsp;zip&nbsp;code.</span></div>');
        $('.rebate-text').html('<div><span style="font-weight: normal; font-size: 13px;">Instant rebates not currently available from <span class="utilityname">' + noUtilityText + '</span>, but we may be able to find downstream rebates and additional savings. <a class="contactus link"/pages/other-savings' + tags + '" style="font-weight: bold;">Inquire</a><span style="font-weight: normal;"> or </span><span class="linewrapper" style="font-weight: normal;"><a class="search-again link" href="#">try&nbsp;another&nbsp;zip&nbsp;code.</a></span></span></div>');
        $('.rebatefootnote').hide();
        $('.first-search-box').show();
      }
      else {
        $('.rbbox').show();
        var responseUtility = responseData[Object.keys(responseData)[0]].Utility;
        var tags = "?s=" + $('.sku').val() + "&z=" + $('.zip_code').val() + "&u=" + $('.utilities option:selected').text().replaceAll("&", "%26");
        if (status == "Success") {
          // If Briteswitch only returns Prescriptive rebates for this zip/utility/product,
          // treat as a non-instant-only response and stop further processing.
          function rfIsPrescriptiveOnly(data) {
            var sawAny = false;
            for (var k in data) {
              sawAny = true;
              var t = (data[k] && data[k].RebateType != null) ? String(data[k].RebateType) : '';
              if (t !== 'Prescriptive') return false;
            }
            return sawAny;
          }

          if (rfIsPrescriptiveOnly(responseData)) {
            var prescriptiveUtilityText = responseUtility.replace(/ - [A-Za-z]{2}$/, '').replace(/ Co$/, '');

            var warn = document.querySelector('.rebate_container .rf-warn');
            var success = document.querySelector('.rebate_container .rf-success');
            if (success) success.style.display = 'none';

            if (warn) {
              var ICON_PHONE = 'https://cdn.shopify.com/s/files/1/0553/0605/9812/files/Phone-rebate100x100.svg?v=1770905021';
              var ICON_MSG = 'https://cdn.shopify.com/s/files/1/0553/0605/9812/files/Message-rebate100x100.svg?v=1770905021';

              warn.innerHTML = [
                '<h4>' + prescriptiveUtilityText + ' does not offer instant rebates for this product.</h4>',
                '<p class="other-rebates">Other rebates may still be available. Call or text us to confirm options.</p>',
                '<div class="rebate-finder__cta">',
                '<p><b>Need help?</b> Call <a href="tel:2153557200">215-355-7200</a> or email <a href="mailto:lights@eledlights.com">lights@eledlights.com</a> to speak with a member of our team.</p>',
                '</div>',
                '<p>Planning a larger project? <strong><a href="/pages/other-savings' + tags + '">Reach out for a bulk price quote</a></strong>.</p>'
              ].join('');
              warn.style.display = '';
            }

            // Stop: we are intentionally not rendering the instant-rebate success panel.
            return;
          }

          var final;
          var resultArr = [];
          for (let key in responseData) {
            var row = responseData[key];
            if (row.RebateType == "Midstream") {
              resultArr.push(row)
            }
          }
          if (resultArr.length === 0) {
            // Prescriptive or custom (treat as FAIL for Instant Rebates mockup)
            var utilityUnavailableText = responseUtility.replace(/ - [A-Za-z]{2}$/, '').replace(/ Co$/, '');

            var warn = document.querySelector('.rebate_container .rf-warn');
            var success = document.querySelector('.rebate_container .rf-success');
            if (success) success.style.display = 'none';
            if (warn) {
              var ICON_PHONE = 'https://cdn.shopify.com/s/files/1/0553/0605/9812/files/Phone-rebate100x100.svg?v=1770905021';
              var ICON_MSG = 'https://cdn.shopify.com/s/files/1/0553/0605/9812/files/Message-rebate100x100.svg?v=1770905021';

              warn.innerHTML = [
                '<h4>' + utilityUnavailableText + ' does not offer instant rebates for this product.</h4>',
                '<div class="rebate-finder__cta">',
                '<p><b>Need help?</b> Call <a href="tel:2153557200">215-355-7200</a> or email <a href="mailto:lights@eledlights.com">lights@eledlights.com</a> to speak with a member of our team.</p>',
                '</div>',
                '<p>Planning a larger project? <strong><a href="/pages/other-savings' + tags + '">Reach out for a bulk price quote</a></strong>.</p>'
              ].join('');
              warn.style.display = '';
        }

            $('.single-result').html('<div class="rebate_result">Instant rebates not currently available from <span class="utilityname">' + utilityUnavailableText + '</span>, but we may be able to find downstream rebates and additional savings. <a class="contactus link" href="/pages/other-savings' + tags + '" style="font-weight: bold;">Inquire</a><span style="font-weight: normal;"> or </span><span class="linewrapper" style="font-weight: normal;">try&nbsp;another&nbsp;zip&nbsp;code.</span></div>');
            $('.rebate-text').html('<div><span style="font-weight: normal; font-size: 13px;">Instant rebates not currently available from <span class="utilityname">' + utilityUnavailableText + '</span>, but we may be able to find downstream rebates and additional savings.</span> <a class="contactus link normal" style="font-weight: bold;; font-size: 13px;"/pages/other-savings' + tags + '">Inquire</a><span style="font-weight: normal; font-size: 13px;"> or </span><span class="linewrapper" style="font-weight: normal; font-size: 13px;"><a class="search-again link" href="#">try&nbsp;another&nbsp;zip&nbsp;code.</a></span></div>');
            $('.rebatefootnote').html(newRebateSearch.noUtilNote);
            $('.rebatefootnote').hide();
            $('.first-search-box').show();
          } else {
            if (responseUtility == "PECO Energy Co - PA" || responseUtility == "PSE&G - Public Service Elec & Gas Co - NJ") {
              let correctRebate;
              if (resultArr.length > 1) {
                let allEqual = true;
                const firstAmount = resultArr[0]?.RebateAmount
                for (let i = 0; i < resultArr.length; i++) {
                  if (resultArr[i].RebateName == newRebateSearch.rebateCategory) {
                    correctRebate = resultArr[i];
                    break;
                  } else if (resultArr[i].RebateAmount != firstAmount) {
                    allEqual = false; // Found a different value
                  }
                }
                if (allEqual == true) {
                  correctRebate = resultArr[0];
                } else {
                  console.log("Actually not all equal")
                }
              } else {
                correctRebate = resultArr[0];
              }
              final = {
                amount: parseFloat(correctRebate.RebateAmount),
                per: correctRebate.AmountPer
              }
            } else {
              // For most utilities, briteswitch does NOT return a top-level maximum_rebate.
              // Use the highest Midstream RebateAmount from resultArr.
              let best = resultArr[0];
              for (let i = 1; i < resultArr.length; i++) {
                if (parseFloat(resultArr[i].RebateAmount) > parseFloat(best.RebateAmount)) {
                  best = resultArr[i];
                }
              }
              final = {
                amount: parseFloat(best.RebateAmount),
                per: best.AmountPer
              }
            }
            console.log(final)
            var rebate_amount = parseFloat(final.amount).toFixed(2);
            var prod_type = (final.per || '').toLowerCase();

            if (final.amount) {
              var utilityFinalText = responseUtility.replace(/ - [A-Za-z]{2}$/, '').replace(/ Co$/, '');
              // ---- Mockup #2 success panel (new UI) ----
              (function renderSuccessPanel() {
                var success = document.querySelector('.rebate_container .rf-success');
                var warn = document.querySelector('.rebate_container .rf-warn');
                if (warn) warn.style.display = 'none';

                if (!success) return;

                var amountTxt = '$' + rebate_amount + ' off per ' + prod_type;
                var utilityTxt = utilityFinalText;

                // Default CTA target: standalone rebate assistant page.
                var completeFormHref = '/pages/instant-rebates' + tags;

                // Shopify-hosted SVGs
                var ICON_PHONE = 'https://cdn.shopify.com/s/files/1/0553/0605/9812/files/homepage-phone-icon-green.svg?v=1778075638';
                var ICON_MSG = 'https://cdn.shopify.com/s/files/1/0553/0605/9812/files/homepage-text-icon-green.svg?v=1778075657';

                success.innerHTML = [
                  '<h4>Great News! Get ' + amountTxt + ' with ' + utilityTxt + ' rebates.</h4>',
                  '<p class="handle-rebate-text">For commercial ' + utilityTxt + ' customers, we handle the rebate and apply it directly to your order.</p>',
                  '<div class="rebate-finder__ready">How to Get Your Rebate:</div>',
                  '<div class="rebate-finder__cta">',
                  '<p><img class="rebate-finder__icon-img" alt="" src="' + ICON_PHONE + '">Call <a href="tel:2153557200">215.355.7200</a></p>',
                  '<p><img class="rebate-finder__icon-img" alt="" src="' + ICON_MSG + '">Text <a href="sms:8586509400">858.650.9400</a></p>',
                  '</div>',
                  '<p>Or, <button onclick="openForm(\'rebate-product-details-form\')">submit your project details</button> to confirm rebate eligibility</p>'
                ].join('');

                success.style.display = '';
              })();

              // Legacy HTML writes (now same for all utilities; PECO "easyrebates" flow is retired)
              $('.single-result').html('<div class="rebate_result"><span class="bigredtext">Rebate available for up to $' + rebate_amount + '/' + prod_type + '*</span></div>');
              $('.rebate-text').html('<div class="greentext"><a class="contactus link" href="/pages/instant-rebates' + tags + '">Rebate available for up to $' + rebate_amount + '/' + prod_type + '*</a></div>');
              $('.rebatefootnote').html(newRebateSearch.rebateNote.replace("{}", utilityFinalText));
              $('.rebatefootnote').show();
              $('.first-search-box').show();
            } else {
              // Rebate amount is zero (treat as FAIL for Instant Rebates mockup)
              var warn = document.querySelector('.rebate_container .rf-warn');
              var success = document.querySelector('.rebate_container .rf-success');
              if (success) success.style.display = 'none';
              if (warn) {
                var ICON_PHONE = 'https://cdn.shopify.com/s/files/1/0553/0605/9812/files/Phone-rebate100x100.svg?v=1770905021';
                var ICON_MSG = 'https://cdn.shopify.com/s/files/1/0553/0605/9812/files/Message-rebate100x100.svg?v=1770905021';

                warn.innerHTML = [
                  '<h4>Rebate may be available, but more information may be required.</h4>',
                  '<div class="rebate-finder__cta">',
                  '<p><b>Need help?</b> Call <a href="tel:2153557200">215-355-7200</a> or email <a href="mailto:lights@eledlights.com">lights@eledlights.com</a> to speak with a member of our team.</p>',
                  '</div>',
                ].join('');
                warn.style.display = '';
              }

              $('.single-result').html('<div class="rebate_result"><span class="bigredtext">Rebate available but more information may be required</span><br><span class="smallerfont"><a class="contactus link"/pages/instant-rebates' + tags + '">Contact&nbsp;Us&nbsp;to&nbsp;Redeem</a> or <span class="linewrapper">check&nbsp;another&nbsp;zip&nbsp;code.</span></span></div>');
              $('.rebate-text').html('<div class="greentext"><a class="contactus link" href="/pages/instant-rebates' + tags + '">Rebate available but more information may be required*</a></div>');
              $('.rebatefootnote').html('<span class="smallerfont"><a class="contactus link"/pages/instant-rebates' + tags + '">Contact&nbsp;Us&nbsp;to&nbsp;Redeem</a> </span><span> <span style="font-weight: normal;">or</span> <a class="search-again link" href="#">check another zip code</a>.</span>');
              $('.rebatefootnote').show();
              $('.first-search-box').show();
            }
          }

        } else if (status == "No rebates") {
          var noUtilityText = JSON.parse(requestData).utility.replace(/ - [A-Za-z]{2}$/, '').replace(/ Co$/, '');

          var warn = document.querySelector('.rebate_container .rf-warn');
          var success = document.querySelector('.rebate_container .rf-success');
          if (success) success.style.display = 'none';

          if (warn) {
            var ICON_PHONE = 'https://cdn.shopify.com/s/files/1/0553/0605/9812/files/Phone-rebate100x100.svg?v=1770905021';
            var ICON_MSG = 'https://cdn.shopify.com/s/files/1/0553/0605/9812/files/Message-rebate100x100.svg?v=1770905021';

            warn.innerHTML = [
              '<h4>' + noUtilityText + ' does not offer instant rebates for this product.</h4>',
              '<div class="rebate-finder__cta">',
              '<p><b>Need help?</b> Call <a href="tel:2153557200">215-355-7200</a> or email <a href="mailto:lights@eledlights.com">lights@eledlights.com</a> to speak with a member of our team.</p>',
              '</div>',
              '<p>Planning a larger project? <strong><a href="/pages/other-savings' + tags + '">Reach out for a bulk price quote</a></strong>.</p>'
            ].join('');
            warn.style.display = '';
        }

          $('.single-result').html('<div class="rebate_result">Instant rebates not currently available from <span class="utilityname">' + noUtilityText + '</span>, but we may be able to find downstream rebates and additional savings. <a class="contactus link" href="/pages/other-savings' + tags + '" style="font-weight: bold;">Inquire</a><span style="font-weight: normal;"> or </span><span class="linewrapper" style="font-weight: normal;">try&nbsp;another&nbsp;zip&nbsp;code.</span></div>');
          $('.rebate-text').html('<div><span style="font-weight: normal; font-size: 13px;">Instant rebates not currently available from <span class="utilityname">' + noUtilityText + '</span>, but we may be able to find downstream rebates and additional savings. <a class="contactus link" href="/pages/other-savings' + tags + '" style="font-weight: bold;">Inquire</a><span style="font-weight: normal;"> or </span><span class="linewrapper" style="font-weight: normal;"><a class="search-again link" href="#">try&nbsp;another&nbsp;zip&nbsp;code.</a></span></span></div>');
          $('.rebatefootnote').hide();
        }
      }
    }
  },

  errorResponse: function () {
    $('.single-result').html('<div class="rebate_result"><span class="bigredtext">Cannot find product</span></div>');
  },
  postData: async function (url, data) {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
      },
      body: data,
    });
    return response.json();
  }

}





function catchTableUpdate() {
  $(document).ajaxStop(function () {
    if (document.getElementById("sortable").rows.length >= 2) {
      sortBy(1);
      sortBy(1);
      var rows = document.getElementById("sortable").rows;
      $(rows).each(function (key, val) {
        if ($(val).html().indexOf('$') >= 0) {
          $(val).removeClass();
        } else {
          $(val).addClass('light');
        }
      });
      cPrev = -1;
    }
  });
}

/*** Table sort ***/
/*
A few requirements for configuring the table:
1. The table must have id="sortable", i.e. <table id="sortable">
2. The table needs to have a table header, and the table header must have
onclick="sortBy(n)", where n is the column number starting with 0
i.e. <th onclick="sortBy(0)">Title of First Column</th>
*/

cPrev = -1; // global var saves the previous c, used to
// determine if the same column is clicked again

function sortBy(c) {
  rows = document.getElementById("sortable").rows.length; // num of rows
  columns = document.getElementById("sortable").rows[0].cells.length; // num of columns
  arrTable = [...Array(rows)].map(e => Array(columns)); // create an empty 2d array

  for (ro = 0; ro < rows; ro++) { // cycle through rows
    for (co = 0; co < columns; co++) { // cycle through columns
      // assign the value in each row-column to a 2d array by row-column
      if (co === 1 && document.getElementById("sortable").rows[ro].innerHTML.indexOf('$') >= 0) {
        arrTable[ro][co] = parseFloat(document.getElementById("sortable").rows[ro].cells[co].innerHTML);
      } else {
        if (co === 1) {
          arrTable[ro][co] = 0; //document.getElementById("sortable").rows[ro].cells[co].innerHTML;
        } else {
          arrTable[ro][co] = document.getElementById("sortable").rows[ro].cells[co].innerHTML;
        }
      }

      //            console.log(co,arrTable[ro][co]);
    }
  }

  th = arrTable.shift(); // remove the header row from the array, and save it

  if (c !== cPrev) { // different column is clicked, so sort by the new column
    arrTable.sort(
      function (a, b) {
        if (parseFloat(a[c]) === parseFloat(b[c])) {
          return 0;
        } else {
          return (parseFloat(a[c]) < parseFloat(b[c])) ? -1 : 1;
        }
      }
    );
  } else { // if the same column is clicked then reverse the array
    arrTable.reverse();
  }

  cPrev = c; // save in previous c

  arrTable.unshift(th); // put the header back in to the array

  // cycle through rows-columns placing values from the array back into the html table
  for (ro = 0; ro < rows; ro++) {
    for (co = 0; co < columns; co++) {
      document.getElementById("sortable").rows[ro].cells[co].innerHTML = arrTable[ro][co];
    }
  }
}